import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import { useTranslation } from "react-i18next";

const MetadataInputTerritoryCode = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { t } = useTranslation();
  const { onChange, data, value, predefinedValues } = props;
  const values =
    data.values
      ?.filter((v) => v.valueObject !== null && v.valueObject?.value !== null)
      .flatMap((v) => v.valueObject?.value) || [];
  return (
    <Autocomplete
      id={data.tagName!}
      // options management
      options={values}
      disableClearable={data.isMandatory ?? false}
      getOptionLabel={(option: any) => option.isoCodeLocalized + " - " + option.englishName}
      isOptionEqualToValue={(option: any, value: any) =>
        option.isoCodeLocalized === value.isoCodeLocalized || value === ""
      }
      // value management
      //   value={value ? value.value || value : null}
      value={value ? (typeof value.value === "string" ? value : value.value) : null}
      onChange={(e, value) => {
        onChange(value || null, data.id);
      }}
      // render input
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => (
        <OutlinedInput
          {...params.InputProps}
          inputProps={params.inputProps}
          required
          sx={{ width: "100%" }}
          placeholder={t("field:placeholder.selectTerritory")}
        />
      )}
      sx={{ width: "100%" }}
    />
  );
});

export default MetadataInputTerritoryCode;
